import type { VideoProvider } from '@core/interview-events-types';
import { createSingleEntityStore } from '@core/ngrx-legacy';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<VideoProvider[]>()('InterviewVideoProviders');

export {
  actions as InterviewVideoProvidersActions,
  selectors as InterviewVideoProvidersSelectors,
  reducer as InterviewVideoProvidersReducer,
  namespace as InterviewVideoProvidersNamespace,
};
